import { apiUrlDevice } from "~constants";
import Network from "~helpers/Network";

import * as at from "./actionTypes";

export const setDeviceList = (payload) => ({
  type: at.SET_DEVICE_LIST,
  payload,
});

export const getDeviceList =
  (options = {}) =>
  (_dispatch, _getState) => {
    return Network.request(apiUrlDevice.get, {
      onSuccess: (response) => setDeviceList(response.results),
      loading: true,
      ...options,
    });
  };

export const deleteDevice = (id) => (_dispatch, _getState) => {
  return Network.request(apiUrlDevice.delete.format(id), {
    method: "DELETE",
    loading: true,
    successMsg: true,
  });
};

export const updateCurrentDevice =
  (data, options = {}) =>
  (_dispatch, _getState) => {
    return Network.request(apiUrlDevice.updateCurrent, {
      method: "PUT",
      data,
      loading: true,
      successMsg: false,
      ...options,
    });
  };

export const updateActivity = (isActive) => (_dispatch, _getState) => {
  return Network.request(apiUrlDevice.activity, {
    method: "POST",
    data: {
      activity: isActive,
    },
    loading: false,
    successMsg: false,
    noAlert: true,
  });
};
